import { useRecoilState } from 'recoil';
import {
  bottomBarOpenState,
  captionsEnabledState,
  gameSoundOnState,
  gameSoundVolumeState,
} from 'store';
import GameTour from './GameTour';

const GameTourStateWrap = (props) => {
  const [soundOn] = useRecoilState(gameSoundOnState);
  const [volume] = useRecoilState(gameSoundVolumeState);
  const [captionsEnabled, setCaptionsEnabled] = useRecoilState(captionsEnabledState);
  const [isBbOpen, setIsBbOpen] = useRecoilState(bottomBarOpenState);

  return (
    <GameTour
      recoilState={{
        soundOn,
        volume,
        captionsEnabled,
        setCaptionsEnabled,
      }}
      isBbOpen={isBbOpen}
      setIsBbOpen={setIsBbOpen}
      {...props}
    />
  );
};

export default GameTourStateWrap;
